module.exports = __webpack_public_path__ + "static/media/performanceAnalysis.6f53f0f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/estrategas/tools/performanceAnalysis.png
// module id = 612
// module chunks = 0